import React, { useEffect, useState } from 'react';
import { Container, Row, Toast, Modal, Alert, Tab, Tabs, Col, OverlayTrigger, Tooltip } from 'react-bootstrap';
import api from '../../seller-apis/api';
import {
  negotiationReq,
  filterOrdersfilter,
  orderRevoke,
  filterOrders
} from '../../seller-apis/apidataField';
import PaginationCom from '../common/Pagination';
import ConfirmationModal from '../common/ConfirmationModal';
import Popup from '../common/Popup';

import TrackOrderPopup from '../common/TrackOrder-Popup';
import '../order.css';
import OrderCardWeb from '../common/OrderCardWeb';
import { useAlert } from 'react-alert';
import OrderSKUSearch from '../common/ProductSearch/OrderSKUSearch';
import moment from 'moment';
//SL-923
import { useSelector } from 'react-redux';
import MainLoader from '../common/Loader/PageLoader';
import RaiseConcernModal from '../common/RaiseConcernModal';
import { useOrderDateAlert, resetOrderDateFilter, resolveOrderDateRange } from './useOrderDateAlert';

var dateFromWeb = moment().subtract(30, 'days').format('YYYY-MM-DD');
var dateToWeb = moment().format('YYYY-MM-DD');
var dateFrom3days = moment().subtract(4, 'days').format('YYYY-MM-DD');
var datesWeb;

var globalFilter = {
  "pageNo": 1,
  "statusFilter": ["DOWNLOAD"],
  "dates": {

  }
};
var sorted = true;
let gettingBreachingSoon = false;
function ProcessedOrders() {
  const stateData = useSelector(state => state?.ActionReducer);//SL-923
  var outerdiv;
  var loaderDiv;
  const alert = useAlert()
  const showOrderDateAlert = useOrderDateAlert(alert)

  const [revokedOrd, setrevokedOrd] = useState([]);
  const [newOrdersList, setnewOrdersList] = useState([]);
  const [orderHistoryList, setorderHistoryList] = useState([]);
  const [ennewloader, setennewloader] = useState("block");
  const [negotiationRequests, setnegotiationRequests] = useState([]);
  const [newRecords, setnewRecords] = useState();
  const [negotRecords, setnegotRecords] = useState();

  const [selectedOrder, setSelectedOrder] = useState();
  const [showOrders, setShowOrders] = useState("none");


  // Web states

  const [allOrders, setallOrders] = useState([]);
  const [allRecords, setallRecords] = useState(1);
  const [breachingDataCount, setBreachingDataCount] = useState(0);
  const [webFiltCurr, setwebFiltCurr] = useState();
  const [speechRes, setspeechRes] = useState();

  // Pagination related

  const [selectedPage, setSelectedPage] = useState(1);

  const [sortHistdatefrom, setHistsortdatefrom] = useState();
  const [sortHistdateto, setHistsortdateto] = useState();



  // Confirmation related
  const [confirmationState, setconfirmationState] = useState(false)
  const [msgConfirmation, setmsgConfirmation] = useState();
  const [confirmationFor, setconfirmationFor] = useState();
  const [negotiateState, setnegotiateState] = useState();
  const [confirmationType, setconfirmationType] = useState();
  const [selectedOrdername, setSelectedOrdername] = useState();
  // Toast

  const [showToast, setshowToast] = useState(false)
  const [compforPaginationweb, setcompforPaginationweb] = useState("allOrdersWeb");



  // Track order Popup

  const [selectedtrackOrder, setselectedtrackOrder] = useState(0);
  const [selectedTrackwithin, setselectedTrackwithin] = useState(0)

  //Product Detail Popup

  const [productDetail, setproductDetail] = useState([
    {
      "description": undefined,
      "sdescription": undefined,
      "name": undefined,
      "price": undefined,
      "SKU": undefined,
      "popupVisibility": undefined,
      "images": []
    }
  ]);
  const [isDetailPopupVis, setisDetailPopupVis] = useState("block");
  const [defUrl, setdefUrl] = useState();


  // Web filter related states
  const [addressName, setAddressName] = useState("")
  const [orderId, setOrderId] = useState(undefined);
  const [orderName, setorderName] = useState();
  const [isPopupTrackVisWeb, setisPopupTrackVisWeb] = useState("block");
  const [selectedtrackOrderWeb, setselectedtrackOrderWeb] = useState(0);
  const [detailPPrice, setdetailPPrice] = useState("");
  const [minValDate, setMinValDate] = useState("");
  const [maxValDate, setMaxValDate] = useState("");
  const [searchType, setSearchType] = useState("Product Name");
  const [removeFilterClass, setremoveFilterClass] = useState("invent_remove_filter_btn")
  //SL-675
  const [totalRcordId, setTotalReordId] = useState([]);

  const [selectedOrderId, setSelectedOrderId] = useState(null);
  const [show, setShow] = useState(false);
  const [isBreachingFilter, setBreachingFilter] = useState(false);

  // console.log(location.);
  useEffect(() => {
    const { from, to } = resetOrderDateFilter();
    dateFromWeb = from;
    dateToWeb = to;
    setHistsortdatefrom(from);
    setHistsortdateto(to);
    setselectedTrackwithin(0)
    setselectedtrackOrderWeb(0)
    setSelectedPage(1)
    setMaxValDate(moment().format('YYYY-MM-DD'));
    globalFilter = {
      "pageNo": 1,
      "statusFilter": ["DOWNLOAD"],
      "dates": {

      }
    };
    if (dateFromWeb === undefined || dateToWeb === undefined || dateFromWeb === "" || dateToWeb === "") {
      showOrderDateAlert("please select both date", "show");
      return false;
    }
    if (dateFromWeb !== undefined && dateToWeb !== undefined && dateFromWeb !== "" && dateToWeb !=="") {
      let fromDate = new Date(dateFromWeb)
      let toDate = new Date(dateToWeb);
      let diffDate = toDate.getTime() - fromDate.getTime()
      let daydiffer = diffDate / (1000 * 60 * 60 * 24);
      daydiffer = Math.floor(daydiffer)
      if(daydiffer > 30){
          showOrderDateAlert("Date range cannot be more than 30 days.")
          return 0;
      }
      globalFilter.dates = {
        ...globalFilter.dates,
        "from-createdAt": dateFromWeb + 'T00:00:00',
        "to-createdAt": dateToWeb + 'T23:59:59'
      }
    }
    globalFilter.orderFilter = {
      ...globalFilter.orderFilter,
      "products.productId.productName": orderName,
    }
    globalFilter.orderFilter = {
      ...globalFilter.orderFilter,
      "products.vendorDetails.addrName": addressName
    }
    globalFilter.orderFilter = {
      ...globalFilter.orderFilter,
      "orderId": orderId
    }
    applyLoader()
    if(orderId !== undefined || orderName !== undefined || addressName !== undefined || (dateFromWeb !== undefined && dateToWeb !== undefined && dateFromWeb !== "" && dateToWeb !==""))
    {
      setremoveFilterClass("invent_remove_filter_btn_active")
    }
    //SL-675
    globalFilter["productId"] = totalRcordId.length == 0 ? true : false;
    api.order.orders(filterOrders(globalFilter))
    .then((res) => {
      removeLoader()
      setdefUrl("manual-mandava-weeder")
      setallOrders(res.data)
      setallRecords(res.totalRecords)
      if(totalRcordId.length == 0){//SL-675
        setTotalReordId(res?.productId);
        globalFilter["productId"] = false;
      }
    }).catch(err => {
      removeLoader()
      console.log(err)
    })

    // before 3 days data
    const breachingFilter = {
      ...globalFilter,
      dates: {
        ...globalFilter.dates
      },
      orderFilter:{
        ...globalFilter.orderFilter
      },
      size: 1
    }
    breachingFilter.dates["to-createdAt"] = dateFrom3days + 'T00:00:00';
    api.order?.orders(filterOrders(breachingFilter)).then((res) => {
      setBreachingDataCount(res.totalRecords);
      // delete breachingFilter.dates["to-createdAt"];
    }).catch(err => {
      // removeLoader()
      console.log(err)
    })
  }, [])



  useEffect(() => {
    if (addressName === "" || addressName === null) {
      setAddressName(undefined)
    }
  }, [addressName])


  useEffect(() => {
     if (orderId === "" || orderId === null) {
      setOrderId(undefined)
      if (globalFilter?.orderFilter?.orderId){
        delete globalFilter.orderFilter.orderId;
        globalFilter.pageNo = 1;
        setSelectedPage(1)
        getOrders()
      }
    }
  }, [orderId])


  useEffect(() => {
    if (orderName === "" || orderName === null) {
      setorderName(undefined)
    }
  }, [orderName])

  const getOrders = () => {
    try {
      applyLoader()
      api.order.orders(filterOrders(globalFilter)).then((res) => {
        removeLoader()
        setallOrders(res.data)
        setallRecords(res.totalRecords)
      }).catch(err => {
        throw new Error(err)
      })
    } catch (err) {
      removeLoader()
      console.log(err)
    }
  }

  // Order Picked
  function productPicked(id, status, pname) {
    if (status === "ASSIGN") {
      setshowToast(true)
    }
    else if (status === "DOWNLOAD") {
      setSelectedOrder(id)
      setSelectedOrdername(pname)
      setmsgConfirmation("Is product picked up by courier boy?")
      setconfirmationState(true)
    }
  }


  // Manifest Download Confirmation

  function isManifestDownloaded(res) {
    let outerdiv = document.getElementById("orDeskContain");
    let loaderDiv = document.getElementById("enNewLoader");
    loaderDiv.classList.add("loader-bt");
    setennewloader("flex")
    outerdiv.classList.add("div-bk");
    console.log(res)
    console.log(webFiltCurr, compforPaginationweb, datesWeb)
    if (res === "yes") {
      api.order.orders(filterOrders(globalFilter)).then((res) => {
        console.log(res)
        setdefUrl("manual-mandava-weeder")
        setallOrders(res.data)
        setallRecords(res.totalRecords)
        setennewloader("none")
      }).catch(err => {
        setennewloader("none")
        console.log(err)
      })
    }
  }




  // Confirmation Modal

  function confirmationBoxHiding(state) {
    if (state === false) {
      setconfirmationState(false)
    }
  }

  function responseconfirmation(response, id) {
    let data = {
      "_id": id,
      "status": "PICKED"
    }
    if (response === "yes") {
      setconfirmationState(false)
      api.order.updateOrder(data).then((res) => {
        let filterData = {
          "pageNo": selectedPage,
        }
        alert.success("Order status updated")
        api.order.orders(filterOrdersfilter(filterData, ["DOWNLOAD"])).then((res) => {

          setnewOrdersList(res.data)
          setnewRecords(res.totalRecords)
        }).catch(err => {
          console.log(err)
        })
      }).catch((err) => {
        console.log(err)
      })
    }
  }




  // Negotiation confirmation related

  function responseConfirmNegotiate(ans, id) {
    let filterData = {
      "pageNo": selectedPage
    }


    if (ans === "yes") {
      setconfirmationState(false)
      if (negotiateState === "accept") {
        let data = {
          "_id": id,
          "status": "APPROVED"
        }
        api.order.updateOrder((data)).then((res) => {
          alert.success("Offer accepted")
          api.order.orders(negotiationReq(filterData)).then((response) => {
            setnegotiationRequests(response.data)
          }).catch(err => {
            console.log(err)
          })
        }).catch((err) => {
          console.log(err)
        })
      }
      else if (negotiateState === "reject") {
        let data = {
          "_id": id,
          "status": "DISAPPROVED"
        }
        api.order.updateOrder((data)).then((res) => {
          alert.success("Offer rejected")
          api.order.orders(negotiationReq(filterData)).then((response) => {
            setnegotiationRequests(response.data)
          }).catch(err => {
            console.log(err)
          })
        }).catch((err) => {
          console.log(err)
        })
      }
    }
  }



  function setpopupVisibilityDetail(e) {
    if (e) {
      setisDetailPopupVis("block")
    }
    else {
      setisDetailPopupVis("none")
    }
  }


  function setpopupVisibilitytrackWeb(e) {
    if (e) {
      setisPopupTrackVisWeb("block")
    }
    else {
      setisPopupTrackVisWeb("none")
    }
  }



  function trackPopupWeb(e, trackNo, docketNo) {
    setselectedtrackOrderWeb(e)
    setselectedTrackwithin(trackNo)
  }



  function checkevent(e, name, selectedAddress = null) {//SL-923
    // setHistsortdatefrom("")
    // setHistsortdateto("")
    if (e.keyCode === 13) {
      let outerdiv = document.getElementById("orDeskContain");
      let loaderDiv = document.getElementById("enNewLoader");

      if (name === "id" && orderId !== "") {
        loaderDiv.classList.add("loader-bt");
        setennewloader("flex")
        outerdiv.classList.add("div-bk");
        globalFilter.pageNo = 1
        globalFilter.orderFilter = {
          ...globalFilter.orderFilter,
          "orderId": orderId
        }
        setremoveFilterClass("invent_remove_filter_btn_active")
        api.order.orders(filterOrders(globalFilter)).then((res) => {
          console.log(res)
          setallOrders(res.data)
          setallRecords(res.data.length);
          loaderDiv.classList.remove("loader-bt");
          outerdiv.classList.remove("div-bk");
          setennewloader("none")
        }).catch(err => console.log(err));
      }
      else if (name === "name" && orderName !== "") {
        setSelectedPage(1)
        let ordersearchFilter = searchType != 'sku' ? { "products.productId._id": orderName } : { "products.productId._id": orderName };
        loaderDiv.classList.add("loader-bt");
        setennewloader("flex")
        outerdiv.classList.add("div-bk")
        setcompforPaginationweb("webFilt")
        globalFilter.pageNo = 1
        globalFilter.orderFilter = {
          ...ordersearchFilter
        }
        setremoveFilterClass("invent_remove_filter_btn_active")
        api.order.orders(filterOrders(globalFilter)).then((res) => {
          setallOrders(res.data)
          setallRecords(res.totalRecords)
          setwebFiltCurr("name");
          loaderDiv.classList.remove("loader-bt");
          outerdiv.classList.remove("div-bk");
          setennewloader("none")
        }).catch(err => console.log(err));

      }
      else if (name === "address" /*&& addressName !== ""*/) {//SL-923
        setSelectedPage(1)
        setcompforPaginationweb("allOrdersWeb")
        loaderDiv.classList.add("loader-bt");
        setennewloader("flex")
        outerdiv.classList.add("div-bk");
        globalFilter.pageNo = 1;
        globalFilter.orderFilter = {
          ...globalFilter.orderFilter,
          "products.vendorDetails.addrName": selectedAddress //addressName // SL-923
        }
        api.order.orders(filterOrders(globalFilter)).then((res) => {
          setallOrders(res.data)
          setallRecords(res.totalRecords)
          outerdiv.classList.remove("div-bk");
          loaderDiv.classList.remove("loader-bt");
          setennewloader("none")
        }).catch(err => console.log(err));
      }
    }
  }


  // Popup showing detail


  function detail(data, price) {
    setdetailPPrice(price)
    if (data && data[0] === undefined) {
      setproductDetail(
        [
          {
            "description": "No details available",
            "sdescription": "No short description",
            "name": undefined,
            "price": undefined,
            "SKU": undefined,
            "popupVisibility": undefined,
            "images": []
          }
        ]
      )
    }
    else {
      setproductDetail(data)
    }
  }

  // Pagination

  function paginate(data) {
    let loaderDiv = document.getElementById("enNewLoader");
    setennewloader("flex")
    setselectedTrackwithin(0)
    setselectedtrackOrder(0)
    setselectedtrackOrderWeb(0)
    setSelectedPage(data.number)
    globalFilter.pageNo = data.number
    setennewloader("flex");
    api.order.orders(filterOrders(globalFilter)).then((res) => {
      console.log(res.data)
      setallOrders(res.data)
      setallRecords(res.totalRecords)
      loaderDiv.classList.remove("loader-bt");
      setennewloader("none")
    }).catch(err => {
      console.log(err)
      loaderDiv.classList.remove("loader-bt");
      setennewloader("none")
    })
  }



  function setdateweb(e, type) {
    const { from, to } = resolveOrderDateRange(type, e.target.value, dateFromWeb, dateToWeb);
    dateFromWeb = from;
    dateToWeb = to;
    setHistsortdatefrom(from);
    setHistsortdateto(to);
  }



  // Revoke update

  function revCheck(status) {
    console.log(status)
    if (status === "success") {
      alert.success("Updated successfully")
      api.order.orders(orderRevoke()).then((res) => {
        setrevokedOrd(res.data)
      }).catch((err) => {
        console.log(err)
      })
    }
  }


  // Function to close all popups opened

  document.onkeydown = function (evt) {
    evt = evt || window.event;
    if (evt.key === "Esc" || evt.key === "Escape") {
      setconfirmationState(false)
      setisPopupTrackVisWeb("none")
      setisDetailPopupVis("none")
    }
  };


  function applyLoader() {
    loaderDiv = document.getElementById("enNewLoader");
    setennewloader("flex")
  }

  // remove loader

  function removeLoader() {
    setennewloader("none")
  }

  function clearFilters() {
    applyLoader()
    setcompforPaginationweb("allOrdersWeb")
    globalFilter = {
      "pageNo": 1,
      "statusFilter": ["DOWNLOAD"],
      "dates": {

      }
    }
    setorderName("")
    setOrderId("")
    setAddressName("")
    setHistsortdatefrom("")
    setHistsortdateto("")
    dateFromWeb = ""
    dateToWeb = ""
    setSelectedPage(1)
    setselectedTrackwithin(0)
    setselectedtrackOrder(0)
    setselectedtrackOrderWeb(0)
    api.order.orders(filterOrders(globalFilter)).then((res) => {
      console.log(res)
      removeLoader()
      setremoveFilterClass("invent_remove_filter_btn")
      setdefUrl("manual-mandava-weeder")
      setallOrders(res.data)
      setallRecords(res.totalRecords)
      setennewloader("none")
    }).catch(err => {
      setennewloader("none")
      console.log(err)
    })
  }

  function applyFilter() {
    setselectedTrackwithin(0)
    setselectedtrackOrderWeb(0)
    setSelectedPage(1)
    globalFilter.pageNo = 1
    if (!gettingBreachingSoon && dateFromWeb === undefined || dateToWeb === undefined || dateFromWeb === "" || dateToWeb === "") {
      showOrderDateAlert("please select both date", "show");
      return false;
    }
    // code comented on SL-1217
    if (!gettingBreachingSoon && dateFromWeb !== undefined && dateToWeb !== undefined && dateFromWeb !== "" && dateToWeb !== "") {
      let fromDate = new Date(dateFromWeb)
      let toDate = new Date(dateToWeb);
      let diffDate = toDate.getTime() - fromDate.getTime()
      let daydiffer = diffDate / (1000 * 60 * 60 * 24);
      daydiffer = Math.floor(daydiffer)
      if (daydiffer > 30) {
        showOrderDateAlert("Date range cannot be more than 30 days.")
        return 0;
      }
      globalFilter.dates = {
        ...globalFilter.dates,
        "from-createdAt": dateFromWeb + 'T00:00:00',
        "to-createdAt": dateToWeb + 'T23:59:59'
      }
    }
    globalFilter.orderFilter = {
      ...globalFilter.orderFilter,
      "products.productId.productName": orderName,
    }
    globalFilter.orderFilter = {
      ...globalFilter.orderFilter,
      "products.vendorDetails.addrName": addressName
    }
    globalFilter.orderFilter = {
      ...globalFilter.orderFilter,
      "orderId": orderId
    }
    applyLoader()
    if (orderId !== undefined || orderName !== undefined || addressName !== undefined || (dateFromWeb !== undefined && dateToWeb !== undefined && dateFromWeb !== "" && dateToWeb !== "")) {
      setremoveFilterClass("invent_remove_filter_btn_active")
    }
    api.order.orders(filterOrders(globalFilter))
    .then((res) => {
      removeLoader()
      setdefUrl("manual-mandava-weeder")
      setallOrders(res.data)
      setallRecords(res.totalRecords)
      gettingBreachingSoon = false;
    }).catch(err => {
      gettingBreachingSoon = false;
      removeLoader()
      console.log(err)
    })

    // before 3 days data
    const breachingFilter = {
      ...globalFilter,
      dates: {
        ...globalFilter.dates
      },
      size: 1
    }
    breachingFilter.dates["to-createdAt"] = dateFrom3days + 'T00:00:00';
    api.order?.orders(filterOrders(breachingFilter)).then((res) => {
      setBreachingDataCount(res.totalRecords);
      // delete breachingFilter.dates["to-createdAt"];
    }).catch(err => {
      // removeLoader()
      console.log(err)
    })
  }

  const filterSearch=(data)=>{
    //setorderName(data.data);
    //setSearchType(data.type)
    applyLoader();
    globalFilter['filters'] = { ...globalFilter.filters, "product-objectId": data.data }
    //Search Issue on Other than 1st Page SL-698 and SL-675
    if(globalFilter?.searchIds)
      delete globalFilter['searchIds'];
    globalFilter.pageNo = 1;
    setSelectedPage(1)
    api.order?.orders(filterOrders(globalFilter))
    .then((res) => {
      removeLoader()
      setallOrders(res.data)
      setallRecords(res.totalRecords)
    }).catch(err => {
      removeLoader()
      console.log(err)
    })
    if(globalFilter?.filters && globalFilter['filters']['product-objectId'])
      delete globalFilter['filters']['product-objectId'];
  }

  useEffect(() => {
    if (orderName !== "" && orderName !== null && orderName !== undefined) {
      checkevent({ "keyCode": 13 }, "name");
    }
  }, [orderName])

  const sort = (field) => {
    globalFilter.sortFilter = {};
    if (sorted) {
      sorted = false;
      globalFilter.sortFilter[field] = 1;
    } else {
      sorted = true;
      globalFilter.sortFilter[field] = -1;
    }
    applyFilter();
  }
  /**
   * Apply breaching Soon FIlter
   */
  function applyBreachingSoonFilter() {
    gettingBreachingSoon = true;
    setBreachingFilter(true);
    globalFilter.dates = {
      ...globalFilter.dates,
      // "from-createdAt": dateFrom3days + 'T00:00:00',
        "to-createdAt": dateFrom3days + 'T00:00:00'
    }
    applyFilter();
  }

  /**
 * Remove breaching Soon FIlter
 */
  function removeBreachingSoonFilter() {
    const { from, to } = resetOrderDateFilter();
    dateFromWeb = from;
    dateToWeb = to;
    gettingBreachingSoon = false;
    setBreachingFilter(false);
    globalFilter.dates = {
      ...globalFilter.dates,
            "to-createdAt": dateToWeb + 'T23:59:59'
    }
    if (globalFilter?.dates?.["to-updatedAt"]) {
      delete globalFilter?.dates["to-updatedAt"];
    }
    applyFilter();
  }

  //<Start-Here> Serach Ticket: SL-675
  /**
  * API Calling
  */
  const ApiCalling = (flag) => {
    applyLoader()
    if (globalFilter?.searchIds)
      delete globalFilter['searchIds'];
    globalFilter.pageNo = selectedPage;
    if (flag === "reset") {
      delete globalFilter?.filters?.["product-objectId"];
      globalFilter.pageNo = 1;
      setSelectedPage(1)
    }
    api.order?.orders(filterOrders(globalFilter))
      .then((res) => {
        removeLoader()
        setallOrders(res.data)
        setallRecords(res.totalRecords)
      }).catch(err => {
        removeLoader()
        console.log(err)
      })
  }

 /**
  * Search By Keyword On Enter
  */
  const searchByKeyword = (value, type, productIds) => {
    
    if(productIds.length > 0){
      applyLoader()
      if (type === "sku") {
        globalFilter['filters'] = { ...globalFilter.filters, "product-objectId": productIds?.[0] }
        if (globalFilter?.searchIds)
          delete globalFilter['searchIds'];
      }
      else {
        globalFilter['searchIds'] = productIds
      }
      //Search Issue on Other than 1st Page SL-698 and SL-675
      globalFilter.pageNo = 1;
      setSelectedPage(1);
      api.order?.orders(filterOrders(globalFilter))
      .then((res) => {
        removeLoader()
        setallOrders(res.data)
        setallRecords(res.totalRecords)
      }).catch(err => {
        removeLoader()
        console.log(err)
      })
      
     
    }
    else{
      setallOrders([]);
      setallRecords(0);
      
    }
  }
  //</End-Here> Serach Ticket: SL-675

    /**
   * Show the Raise Concern Modal
   */
  function showRaiseConcern(orderId) {
    setSelectedOrderId(orderId);
    setShow(true);
  }
  /**
   * Close the Raise Concern Modal
   */
  const handleRaiseConcernClose = () => {
    setShow(false);
  };
  /**
   * Submit the Raise Concern
   */
  const submitRaiseConcern = (concern) => {
    setShow(false);
    const breachingConcern = {
      concern,
      orderId: selectedOrderId
    }
    api.order?.breachingConcern(breachingConcern).then((res) => {
      alert.info("Concern Submitted Successfully!");
    }).catch(err => {
      console.log(err)
    })
  }

  return (
    <>

      <div className="" id="orDeskContain">
        {/* New orders desktop */}
        <div class="tab">
          <div className='d-flex mb-3 justify-content-start'>
            {/* ******** */}
            <div className='theme-shed1 p-2'>
              <div className='m-auto mt-1'>
                <span className='payment_dates'>From: - <input type='date' min={minValDate} max={sortHistdateto || maxValDate || undefined} value={sortHistdatefrom} onChange={(e) => setdateweb(e, "from")}></input></span>
                <span className='mx-2 payment_dates'>To: - <input type='date' min={sortHistdatefrom || minValDate || undefined} value={sortHistdateto} onChange={(e) => setdateweb(e, "to")} max={maxValDate}></input></span>
                <span><button className='apply-btn px-3 py-1 ff_Pop fs-14' onClick={() => applyFilter()}>Apply</button></span>
                {/* <span><button className={`payment_btn_export px-3 py-1 ff_Pop fs-14 ms-1 ${removeFilterClass}`} onClick={() => clearFilters()}>Clear</button></span> */}
                {isBreachingFilter && <span><button className={`payment_btn_export px-3 py-1 ff_Pop fs-14 ms-1 ${removeFilterClass}`} onClick={() => removeBreachingSoonFilter()}>Clear</button></span>}
                {breachingDataCount > 0 &&
                  <span>
                    <button className='apply-btn px-3 py-1 ff_Pop fs-14 breachingBtn' onClick={() => applyBreachingSoonFilter()}>
                      <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                      Breaching Soon({breachingDataCount})
                      <OverlayTrigger
                        key="transfer"
                        placement="right"
                        overlay={
                          <Tooltip
                            id={`tooltip-transfer`}
                            className="fs-10 order_page_tooltip"
                          >
                            <p className="fs-10 f-500 order_page_tooltip_1">
                              Late dispatch will imact your rating <br />
                              and might lead to penalty in future
                            </p>
                          </Tooltip>
                        }
                      >
                        <i class="bi bi-info-circle ms-1"></i>
                      </OverlayTrigger>
                    </button>
                  </span>}
              </div>
            </div>
            {/* ****** */}
          </div>
          <div className="table-responsive">
            <table className='ord_table new-table-design' style={{ "width": "100%" }}>
              <thead>
                <tr className='table_ord_title_row'>

                  <th className='thead_title' style={{ "width": "10%" }}>Order ID
                    <br></br>
                    <input type="text" value={orderId} name="name" placeholder='Search' className='w-90 order_table_srch_input' onChange={(e) => setOrderId(e.target.value)} onKeyUp={(e) => checkevent(e, "id")} />
                    <i class="fa fa-search pointer search-space order_table_srch_input_icon" aria-hidden="true" onClick={() => checkevent({ "keyCode": 13 }, "id")}></i>
                  </th>

                  <th className='thead_title pb-1' style={{ "width": "12%" }}>Date<br></br>
                    <input type="date" name="name" className='input-date' min={minValDate} max={sortHistdateto || maxValDate || undefined} value={sortHistdatefrom} onChange={(e) => setdateweb(e, "from")} />
                    <input type="date" name="name" className='input-date' min={sortHistdatefrom || minValDate || undefined} max={maxValDate} value={sortHistdateto} onChange={(e) => setdateweb(e, "to")} />
                    <br></br>
                  </th>

                  <th className='thead_title' style={{ "width": "8%" }}>Product image</th>

                  <th className='thead_title' style={{ "width": "20%" }}>Product Name & SKU
                  <br/>
                  <OrderSKUSearch 
                  filterSearch={filterSearch}
                  searchNewEnq={setorderName}
                  from={"orders"}
                  flag="Order" // set flag
                  apiCall={ApiCalling}
                  data="filedData"
                  totalRcordId={totalRcordId}
                  searchByKeyword={searchByKeyword}
                  apiurl="searchSellerOrdersFilter"
                  ordersSearchParam={filterOrders(globalFilter)}
                  />
                </th>

                <th className='thead_title' style={{ "width": "10%" }}>Transfer price</th>
                {stateData?.addresses?.data?.length > 0 &&<th className='thead_title' style={{ "width": "10%" }}>Pickup Address
                   {/*<Start-Here> Pickup Address Dropdown | Ticket : SL-923 */}
                    <div className="dropdown-wrapper">
                      <select 
                        value={addressName}
                        onChange={(e)=>{
                          const value = e.target.value;
                          setAddressName(value);
                          //Immediately trigger search after selection
                          checkevent({ keyCode: 13 }, "address",value);
                        }}
                      >
                          <option value="">All</option>
                          {stateData?.addresses?.data.map((address) => (
                            <option key={address._id} value={address.firstName}>
                              {address.firstName}
                            </option>
                          ))}
                      </select>
                    </div>
                  {/*</End-Here> Pickup Address Dropdown | Ticket : SL-923 */}
                  {/*<input type="text" value={addressName} name="name" id="inputnameweb" placeholder='Search..' className='w-95 order_table_srch_input' onChange={(e) => setAddressName(e.target.value)} onKeyUp={(e) => checkevent(e, "address")} />
                  <i className="fa fa-search pointer search-space order_table_srch_input_icon" aria-hidden="true" onClick={() => checkevent({ "keyCode": 13 }, "address")}></i>*/}
                </th>}
                <th className='thead_title' style={{ "width": "5%" }}>Total package</th>
                <th className='thead_title' style={{ "width": "10%" }}>Order Pending From
                  <i class="fa fa-sort" onClick={() => sort('createdAt')}></i>
                </th>
                <th className='thead_title' style={{ "width": "5%" }}>Logistics</th>
                <th className='thead_title' style={{ "width": "19%" }}>Action required</th>
              </tr>

            </thead>
            <tbody>
              {allOrders.length > 0 ? allOrders.map((item, index) => {
                let baseImg;
                let date = new Date(item?.order?.orderPlaceDate || item.createdAt);
                let d = date.toUTCString(item?.order?.orderPlaceDate || item.createdAt);
                let newd = d.substr(4, 12)
                let update = new Date(item.updatedAt);
                let upd = update.toUTCString(item.updatedAt);
                let upnewd = upd.substr(4, 12)
                if (item?.order?.products?.length > 0) {
                  item?.order?.products?.[0]?.productId?.images.map((item) => {
                    if (item.baseImage === true) {
                      if (item.image.startsWith("products")) {
                        baseImg = item.image;
                      }
                      else {
                        let img = item.image.substr("41")
                        baseImg = img;
                      }
                    }
                    })
                    if (item.order.products[0].selSubPrd && item.order.products[0].productId.combination) {
                      return (
                        <OrderCardWeb id={index}
                          type="New-Orders"
                          from="processed"
                          key={item._id}
                          updatedAt={upnewd}
                          lead={item._id}
                          nicknameAdd={item.order.products && item.order.products[0] && item.order.products[0].vendorDetails && item.order.products[0].vendorDetails.addrName ? item.order.products[0].vendorDetails.addrName : undefined}
                          taxClass={item.order?.products?.[0]?.vendorDetails?.taxClass}
                          sku={item.order.products[0].productId.SKU}
                          date={newd}
                          actualdate={item.createdAt}
                          orderId={item.order.orderId}
                          url={item.order.products[0].productId.urlKey}
                          productName={item.order.products[0].productId.productName}
                          price={item.order.products[0].purchase_price}
                          quantity={item.order.products[0].quantity}
                          status={item.status}
                          invoices={item.order.products[0].tracks}
                          isProductPickedFun={productPicked}
                          image={baseImg}
                          popupdetailVis={setpopupVisibilityDetail}
                          popupVisibility={setpopupVisibilitytrackWeb}
                          selSubPrdVal={item.order.products[0].selSubPrd.value}
                          pdetail={detail}
                          vendor={item.vendor}
                          revokes={item.order.products[0].revokes}
                          combination={item.order.products[0].productId.combination[0].value}
                          isManifestDownloadedFun={isManifestDownloaded}
                          revokeReason={item.revoke}
                          fun={trackPopupWeb}
                          orderForwardedToSeller={item.order?.orderForwardedToSeller}
                          orderMainId={item.order?._id}
                          docketNotGenerated={item.order?.docketNotGenerated}
                          //Platform Fee Ticket : SL-662
                          platformFee={item.order?.pfFees}
                          product={item.order?.products?.[0]?.productId}
                          order={item.order}
                         showRaiseConcern={showRaiseConcern}
                        />
                      )
                    }
                    else {
                      return (
                        <OrderCardWeb id={index}
                          type="New-Orders"
                          from="processed"
                          key={item._id}
                          nicknameAdd={item.order.products && item.order.products[0] && item.order.products[0].vendorDetails && item.order.products[0].vendorDetails.addrName ? item.order.products[0].vendorDetails.addrName : undefined}
                          updatedAt={upnewd}
                          taxClass={item.order?.products?.[0]?.vendorDetails?.taxClass}
                          lead={item._id}
                          date={newd}
                          pdetail={detail}
                          actualdate={item.createdAt}
                          sku={item.order.products[0].productId.SKU}
                          url={item.order.products[0].productId.urlKey}
                          popupdetailVis={setpopupVisibilityDetail}
                          revokes={item.order.products[0].revokes}
                          orderId={item.order.orderId}
                          productName={item.order.products[0].productId.productName}
                          price={item.order.products[0].purchase_price}
                          quantity={item.order.products[0].quantity}
                          status={item.status}
                          invoices={item.order.products[0].tracks}
                          isProductPickedFun={productPicked}
                          image={baseImg}
                          revokeReason={item.revoke}
                          vendor={item.vendor}
                          popupVisibility={setpopupVisibilitytrackWeb}
                          isManifestDownloadedFun={isManifestDownloaded}
                          fun={trackPopupWeb}
                          orderForwardedToSeller={item.order?.orderForwardedToSeller}
                          orderMainId={item.order?._id}
                          docketNotGenerated={item.order?.docketNotGenerated}
                          //Platform Fee Ticket : SL-662
                          platformFee={item.order?.pfFees}
                          product={item.order?.products?.[0]?.productId}
                          order={item.order}
                           showRaiseConcern={showRaiseConcern}
                        />
                      )
                    }

                  }
                  else {

                    return (
                      <OrderCardWeb id={index}
                        type="New-Orders"
                        key={item._id}
                        lead={item._id}
                        orderId={item?.order?.orderId}
                        status="noprodetail"
                      />
                    )
                  }

                }) : ennewloader === "none" ? (
                  <>
                    <tr className="order-no-results-row">
                      <td colSpan={10} className="order-no-results-cell">No Results Found</td>
                    </tr>
                  </>
                ) : null}
                
              </tbody>
            </table>
          </div>
          {/* </Container> */}

          <div class="d-flex justify-content-center" id="enNewLoader" >
            <div style={{ "display": ennewloader }}>
              <MainLoader/>
            </div>
          </div>

          <PaginationCom
            number={allRecords}
            activ={selectedPage}
            paginate={paginate}
            comp={compforPaginationweb}
          />




        </div>



        {/* </div> */}

        {/* Toast */}
        <Toast show={showToast} className="ToastHome" onClose={() => setshowToast(false)}>
          <Toast.Header>
            <strong className="me-auto">Message</strong>
          </Toast.Header>
          <Toast.Body>Download manifest to proceed with pickup.</Toast.Body>
        </Toast>



        {/* Modal Confirmation */}

        <Modal
          show={confirmationState}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered>

          {confirmationFor === "negotiate" ? <ConfirmationModal
            from="negotiate"
            onHide={confirmationBoxHiding}
            selectedId={selectedOrder}
            msg={msgConfirmation}
            responseconfirmationFun={responseConfirmNegotiate}
          /> : <ConfirmationModal
            type={confirmationType}
            onHide={confirmationBoxHiding}
            pId={selectedOrdername}
            selectedId={selectedOrder}
            msg={msgConfirmation}
            responseconfirmationFun={responseconfirmation}
          />}

        </Modal>

        {/*<Start-Here> Raise Concern Ticket */}
        {show ? (
          <RaiseConcernModal
            show={show}
            handleClose={handleRaiseConcernClose}
            submitRaiseConcern={submitRaiseConcern}
          />
        ) : (
          ""
        )}
        {/*</End-Here> Raise Concern Ticket*/}


        {/* Track detail for web */}


        {allOrders.length > 0 ? <div id="popupTrackweb" className="overlay" style={{ "display": isPopupTrackVisWeb }}>
          {allOrders?.[selectedtrackOrderWeb]?.order.products.length > 0 ? allOrders?.[selectedtrackOrderWeb]?.order?.products?.[0]?.tracks.length > 0 ? <TrackOrderPopup
            type="New-Orders"
            id={allOrders[selectedtrackOrderWeb]._id}
            trackDetail={allOrders?.[selectedtrackOrderWeb]?.order?.products?.[0]?.tracks?.[selectedTrackwithin]?.transitDetail}
            popupVisibility={setpopupVisibilitytrackWeb}
          /> : <></> : <></>}


        </div> : <></>}


        <div id="popupDetail" className="overlay" style={{ "display": isDetailPopupVis }}>
          <Popup
            from="newOrder"
            description={productDetail[0].description}
            sdescription={productDetail[0].shortDescription}
            specificationNew={productDetail[0].specificationNew}
            descriptionNew={productDetail[0].descriptionNew}
            name={productDetail[0].productName}
            price={detailPPrice}
            SKU={productDetail[0].SKU}
            popupVisibility={setpopupVisibilityDetail}
            images={productDetail[0].images}
            videos={productDetail[0].videos}
            fixedImage={true}
          />
        </div>

      </div>
    </>
  )




}


export default ProcessedOrders;